import React, { useState } from "react";
import SearchDialog from "./components/dialog";
import { useConfig } from "./providers/config_provider";

export default function SearchApp() {
  // Ensure we have a valid config
  const { conversationContext } = useConfig();
  const { stylesheet } = conversationContext;

  // Don't render anything until the stylesheet is loaded
  const [stylesLoaded, setStylesLoaded] = useState(false);

  return (
    <>
      {stylesheet && (
        <link
          rel="stylesheet"
          href={stylesheet}
          onLoad={() => {
            setStylesLoaded(true);
          }}
        />
      )}
      {stylesLoaded && <SearchDialog />}
    </>
  );
}
